"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonPropTypes = exports.buttonDefaultProps = exports.stylesPT = exports.stylesProp = undefined;

var _arenaPropTypes = require("arena-prop-types");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styleProps = require("./styleProps");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var shape = _propTypes2.default.shape;
var stylesProp = exports.stylesProp = shape(_styleProps.stylePropTypes);

var stylesPT = exports.stylesPT = function stylesPT(is) {
  return (0, _arenaPropTypes.isRequired)(stylesProp, is);
};

var buttonDefaultProps = exports.buttonDefaultProps = {
  children: ''
};
var buttonPropTypes = exports.buttonPropTypes = {
  children: (0, _arenaPropTypes.nodePT)(),
  onClick: (0, _arenaPropTypes.funcPT)(),
  styleProps: stylesPT()
};